import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Test from "../views/Test";
import MobileHome from "../views/mobile/MobileHome";
import MobileNewsDetails from "../views/mobile/details/MobileNewsDetails";
import feedBack from "../views/mobile/feedBack";

Vue.use(VueRouter)

const routes = [
    {
        path: '/Home',
        name: 'Home',
        component: Home
    },
    {
        path: '/Test',
        name: 'Test',
        component: Test
    },
    {
        path: '/MobileHome',
        name: 'MobileHome',
        component: MobileHome,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/feedsBack',
        name: 'feedsBack',
        component: feedBack,
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/MobileNewsDetails',
        name: 'MobileNewsDetails',
        component: MobileNewsDetails
    }

]


const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})


export default router
